import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { conditionallyRequiredEmailSignup, conditionallyRequiredSelection, conditionallyRequiredText } from '../helpers/Validation';
import * as actions from '../../actions';

class Finish extends Component {
    render() {
        const { firstName, lastName, emailAddress, agreeToTerms } = this.props.questionOptions; 
        return (
            <Fragment>
                <div className="grid offer-signup">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <h1 className="h1">You've completed the discussion guide</h1>
                            <p>You may now download a PDF of your completed discussion guide by clicking "Skip and download my discussion guide" below.</p>
                            <p>If you'd like a copy of your discussion guide emailed to you, sign up for emails below. By signing up, you'll also receive important emails about NUPLAZID, dementia-related hallucinations and delusions, and stories of people navigating these symptoms.</p>
                            <div className="row">
                                <div className="col-lg-10 offset-lg-1">
                                    <div className="form-group relative">
                                        <Field 
                                            name="firstName"
                                            component="input"
                                            validate={conditionallyRequiredText(firstName || lastName || emailAddress || agreeToTerms ? 1 : 0)}
                                            key={"firstname" + (firstName || lastName || emailAddress || agreeToTerms ? 1 : 0)}
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <label className="text-left full-width full-width-input signup-label">First Name</label>
                                                    {meta.error && meta.touched && <div class="drp-signup-guide">{meta.error}</div>}
                                                    <input {...input} className="form-control full-width-input signup-drp-input" type="text" />                                                        
                                                </Fragment>
                                            )}
                                        </Field>
                                        <OnChange name="firstName">
                                            {(value, previous) => {
                                                this.props.questionAnswer("firstName", value);
                                            }}
                                        </OnChange>
                                        <Field 
                                            name="lastName"
                                            component="input"
                                            validate={conditionallyRequiredText(firstName || lastName || emailAddress || agreeToTerms ? 1 : 0)}
                                            key={"lastname" + (firstName || lastName || emailAddress || agreeToTerms ? 1 : 0)}
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <label className="text-left full-width full-width-input signup-label">Last Name</label>
                                                    {meta.error && meta.touched && <div class="drp-signup-guide">{meta.error}</div>}
                                                    <input {...input} className="form-control full-width-input signup-drp-input" type="text" />                                                        
                                                </Fragment>
                                            )}
                                        </Field>
                                        <OnChange name="lastName">
                                            {(value, previous) => {
                                                this.props.questionAnswer("lastName", value);
                                            }}
                                        </OnChange>
                                        <Field
                                            name="emailAddress"
                                            component="input"
                                            validate={conditionallyRequiredEmailSignup(firstName || lastName || emailAddress || agreeToTerms ? 1 : 0)}
                                            key={"email" + (firstName || lastName || emailAddress || agreeToTerms ? 1 : 0)}
                                        >
                                            {({ input, meta }) => (
                                                <Fragment>
                                                    <label className="text-left full-width full-width-input signup-label">Email</label>
                                                    {meta.error && meta.touched && <div class="drp-signup-guide">{meta.error}</div>}
                                                    <input {...input} className="form-control full-width-input signup-drp-input" type="text" placeholder="Example: name@email.com" />                                                        
                                                </Fragment>
                                            )}
                                        </Field>
                                        <OnChange name="emailAddress">
                                            {(value, previous) => {
                                                this.props.questionAnswer("emailAddress", value);
                                            }}
                                        </OnChange>
                                    </div>
                                    <div className="form-group relative">
                                        <label className="inline-checkboxes tos">                            
                                            <Field
                                                name="agreeToTerms"
                                                component="input"
                                                type="checkbox"
                                                validate={conditionallyRequiredSelection(firstName || lastName || emailAddress || agreeToTerms ? 1 : 0)}
                                                key={"tos" + (firstName || lastName || emailAddress || agreeToTerms ? 1 : 0)}
                                            >
                                                {({ input, meta }) => (
                                                    <Fragment>
                                                        <input {...input} value={input.value} checked={input.checked} />
                                                        {meta.error && meta.touched && meta.error }
                                                    </Fragment>
                                                )}
                                            </Field>{' '}
                                            <span></span>
                                            By checking this box, I understand and agree to the <a href="https://www.acadia-pharm.com/privacy/" className="signup-terms-and-privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://www.acadia-pharm.com/terms/" className="signup-terms-and-privacy" target="_blank" rel="noopener noreferrer">Terms of Use</a>. I agree to receive communications from Acadia Pharmaceuticals Inc. 
                                        </label>
                                        <OnChange name="agreeToTerms">
                                            {(value, previous) => {
                                                this.props.questionAnswer("agreeToTerms", value);
                                            }}
                                        </OnChange>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    const { questionOptions } = state;
    return { questionOptions: questionOptions };
}

export default connect(mapStateToProps, actions)(Finish);